<app-protocolo-pesquisar-ipd
    [textoBotaoEnvio]="textoBotaoEnvio"
    [tooltipBotaoEnvio]="tooltipBotaoEnvio"
    [routerLinkEnvioLote]="['/operacoes/cadastro/importacao/lote-ipd']"
    [tiposProtocoloIpd]="tipoConsultaImpedimento"
></app-protocolo-pesquisar-ipd>
